// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host .home-body {
  display: table;
  margin: 0 auto;
}
:host .banner {
  display: flex;
  position: absolute;
  left: 0px;
  top: 0px;
  right: 0px;
  z-index: 999999;
  font-size: 16px;
  padding-left: 25px;
  height: 48px;
  background-color: #B71C1C;
  color: #FFFFFF;
}
:host .banner div {
  display: flex;
  align-items: center;
  margin: auto;
}
:host .banner mat-icon {
  margin-left: 10px;
}
:host .home-container {
  position: absolute;
  left: 0px;
  top: 0px;
  bottom: 0px;
  right: 0px;
  overflow: auto;
}
:host .home-container-nav {
  position: absolute;
  left: 0px;
  top: 48px;
  bottom: 0px;
  right: 0px;
  overflow: auto;
}
:host .home-info {
  text-align: center;
}
:host .header {
  display: flex;
  z-index: 9999 !important;
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12), 0 1px 5px 0 rgba(0, 0, 0, 0.2) !important;
  /* min-height: 46px !important; */
  /* max-height: 46px !important; */
  height: 46px !important;
  padding-left: 4px;
  padding-right: 10px;
  background-color: rgb(255, 255, 255);
  line-height: 46px;
}
:host .header .items {
  flex: 1;
  align-items: center;
  margin-left: 30px;
}
:host .header-login {
  float: right;
  line-height: 46px;
  border-left-width: 1px;
  border-left-style: solid;
  padding-left: 10px;
}
:host .header-login .info {
  display: inline-block;
  line-height: 46px;
  vertical-align: middle;
  max-width: 140px;
}
:host .header-login .primary {
  display: block;
  font-size: 14px;
  font-weight: 600;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: -moz-fit-content;
  max-width: fit-content;
  line-height: 16px;
}
:host .header-login .secondary {
  display: block;
  font-size: 14px;
  font-weight: 100;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: -moz-fit-content;
  max-width: fit-content;
  color: gray;
  line-height: 16px;
}
:host .header-date-time {
  border-left-width: 1px;
  border-left-style: solid;
  padding-left: 10px;
  padding-right: 10px;
  display: inline-block;
}
:host .header-language {
  padding-left: 10px;
  padding-right: 10px;
  display: inline-block;
}
:host .header-button {
  float: right;
  line-height: 46px;
  text-align: right;
  margin-right: 10px;
}
:host .header-button mat-icon {
  font-size: 28px;
  width: 28px;
  height: 28px;
}
:host .button-counter {
  display: inline-block;
  position: absolute;
  bottom: 7px;
  right: 1px;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  text-align: center;
  line-height: 16px;
  font-size: 12px;
  font-weight: bold;
}
:host .alarm-layout {
  position: relative;
  right: 45px;
  display: inline-block;
  width: 40px;
}
:host .info-layout {
  position: relative;
  right: 20px;
  display: inline-block;
  width: 40px;
}
:host .sidenav {
  padding: 0px 0px 0px 0px;
  background-color: rgb(44, 44, 44) !important;
  color: rgb(255, 255, 255) !important;
  /* max-width: 100px; */
  display: inline-block !important;
  top: 0px;
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12), 0 1px 5px 0 rgba(0, 0, 0, 0.2) !important;
}
:host .sidenav-container {
  width: 100%;
  height: 100% !important;
  background-color: #FFFFFF;
}
:host ::ng-deep .mat-drawer-backdrop.mat-drawer-shown {
  background-color: transparent;
}
:host ::ng-deep #myuserinfo {
  padding: unset !important;
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.2), 0 2px 6px 0 rgba(0, 0, 0, 0.18);
}
:host #alarms-panel {
  background: white;
  height: 300px;
  transition: bottom 300ms;
  width: 100%;
  position: fixed;
  bottom: -300px;
}
:host #alarms-panel.is-active {
  bottom: 0px;
  transition: bottom 300ms;
  z-index: 999;
}
:host #alarms-panel.is-full-active {
  top: 46px;
  height: 100%;
  transition: top 300ms;
  z-index: 999;
}`, "",{"version":3,"sources":["webpack://./src/app/home/home.component.scss","webpack://./../../../../%E6%9D%AD%E5%B7%9E%E6%95%B0%E7%BA%B3%E5%B7%9D/IccpPlatform/fuxa/client/src/app/home/home.component.scss"],"names":[],"mappings":"AACI;EACI,cAAA;EACA,cAAA;ACAR;ADEI;EACI,aAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,UAAA;EACA,eAAA;EACA,eAAA;EACA,kBAAA;EACA,YAAA;EACA,yBAAA;EACA,cAAA;ACAR;ADCQ;EACI,aAAA;EACJ,mBAAA;EACA,YAAA;ACCR;ADCQ;EACI,iBAAA;ACCZ;ADGI;EACI,kBAAA;EACA,SAAA;EACA,QAAA;EACA,WAAA;EACA,UAAA;EACA,cAAA;ACDR;ADQI;EACI,kBAAA;EACA,SAAA;EACA,SAAA;EACA,WAAA;EACA,UAAA;EACA,cAAA;ACNR;ADaI;EACI,kBAAA;ACXR;ADcI;EACI,aAAA;EACA,wBAAA;EACA,0HAAA;EACA,iCAAA;EACA,iCAAA;EACA,uBAAA;EACA,iBAAA;EACA,mBAAA;EACA,oCAAA;EACA,iBAAA;ACZR;ADcQ;EACI,OAAA;EACA,mBAAA;EACA,iBAAA;ACZZ;ADgBI;EACI,YAAA;EACA,iBAAA;EACA,sBAAA;EACA,wBAAA;EACA,kBAAA;ACdR;ADgBQ;EACI,qBAAA;EACA,iBAAA;EACA,sBAAA;EACA,gBAAA;ACdZ;ADgBQ;EACI,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,2BAAA;EAAA,sBAAA;EACA,iBAAA;ACdZ;ADgBQ;EACI,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,2BAAA;EAAA,sBAAA;EACA,WAAA;EACA,iBAAA;ACdZ;ADkBI;EACI,sBAAA;EACA,wBAAA;EACA,kBAAA;EACA,mBAAA;EACA,qBAAA;AChBR;ADmBI;EACI,kBAAA;EACA,mBAAA;EACA,qBAAA;ACjBR;ADoBI;EACI,YAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;AClBR;ADqBI;EACI,eAAA;EACA,WAAA;EACA,YAAA;ACnBR;ADqBI;EACI,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,iBAAA;ACnBR;ADsBI;EACI,kBAAA;EACA,WAAA;EACA,qBAAA;EACA,WAAA;ACpBR;ADuBI;EACI,kBAAA;EACA,WAAA;EACA,qBAAA;EACA,WAAA;ACrBR;ADwBI;EACI,wBAAA;EACA,4CAAA;EACA,oCAAA;EACA,sBAAA;EACA,gCAAA;EACA,QAAA;EACA,0HAAA;ACtBR;ADyBI;EACI,WAAA;EACA,uBAAA;EACA,yBAAA;ACvBR;AD0BI;EACI,6BAAA;ACxBR;AD2BI;EACI,yBAAA;EACA,2EAAA;ACzBR;AD4BI;EACI,iBAAA;EACA,aAAA;EACA,wBAAA;EACA,WAAA;EACA,eAAA;EACA,cAAA;AC1BR;AD6BI;EACI,WAAA;EACA,wBAAA;EACA,YAAA;AC3BR;AD8BI;EACI,SAAA;EACA,YAAA;EACA,qBAAA;EACA,YAAA;AC5BR","sourcesContent":[":host {\n    .home-body {\n        display: table;\n        margin: 0 auto;\n    }\n    .banner {\n        display: flex;\n        position: absolute;\n        left: 0px;\n        top:0px;\n        right: 0px;\n        z-index: 999999;\n        font-size: 16px;\n        padding-left: 25px;\n        height: 48px;\n        background-color: #B71C1C;\n        color:#FFFFFF;\n        div {\n            display: flex;\n        align-items: center;\n        margin: auto;\n        }\n        mat-icon {\n            margin-left: 10px;\n        }\n    }\n\n    .home-container {\n        position: absolute;\n        left: 0px;\n        top:0px;\n        bottom: 0px;\n        right: 0px;\n        overflow: auto;\n        // -webkit-user-select: none;\n        // -moz-user-select: none;\n        // -ms-user-select: none;\n        // -o-user-select: none;\n        // user-select: none;\n    }\n    .home-container-nav {\n        position: absolute;\n        left: 0px;\n        top:48px;\n        bottom: 0px;\n        right: 0px;\n        overflow: auto;\n        // -webkit-user-select: none;\n        // -moz-user-select: none;\n        // -ms-user-select: none;\n        // -o-user-select: none;\n        // user-select: none;\n    }\n    .home-info {\n        text-align: center;\n    }\n\n    .header {\n        display: flex;\n        z-index: 9999 !important;\n        box-shadow: 0 2px 2px 0 rgba(0,0,0,0.14), 0 3px 1px -2px rgba(0,0,0,0.12), 0 1px 5px 0 rgba(0,0,0,0.2) !important;\n        /* min-height: 46px !important; */\n        /* max-height: 46px !important; */\n        height: 46px !important;\n        padding-left: 4px;\n        padding-right: 10px;\n        background-color: rgba(255, 255, 255, 1);\n        line-height: 46px;\n\n        .items {\n            flex: 1;\n            align-items: center;\n            margin-left: 30px;\n        }\n    }\n\n    .header-login {\n        float: right;\n        line-height: 46px;\n        border-left-width: 1px;\n        border-left-style: solid;\n        padding-left: 10px;\n\n        .info {\n            display: inline-block;\n            line-height: 46px;\n            vertical-align: middle;\n            max-width: 140px;\n        }\n        .primary {\n            display: block;\n            font-size: 14px;\n            font-weight: 600;\n            overflow: hidden;\n            text-overflow: ellipsis;\n            white-space: nowrap;\n            max-width: fit-content;\n            line-height: 16px;\n        }\n        .secondary {\n            display: block;\n            font-size: 14px;\n            font-weight: 100;\n            overflow: hidden;\n            text-overflow: ellipsis;\n            white-space: nowrap;\n            max-width: fit-content;\n            color: gray;\n            line-height: 16px;\n        }\n    }\n\n    .header-date-time {\n        border-left-width: 1px;\n        border-left-style: solid;\n        padding-left: 10px;\n        padding-right: 10px;\n        display: inline-block;\n    }\n\n    .header-language {\n        padding-left: 10px;\n        padding-right: 10px;\n        display: inline-block;\n    }\n\n    .header-button {\n        float: right;\n        line-height: 46px;\n        text-align: right;\n        margin-right: 10px;\n    }\n\n    .header-button mat-icon {\n        font-size: 28px;\n        width: 28px;\n        height:28px;\n    }\n    .button-counter {\n        display: inline-block;\n        position: absolute;\n        bottom: 7px;\n        right: 1px;\n        width: 16px;\n        height: 16px;\n        border-radius: 50%;\n        text-align: center;\n        line-height: 16px;\n        font-size: 12px;\n        font-weight: bold;\n    }\n\n    .alarm-layout {\n        position: relative;\n        right: 45px;\n        display: inline-block;\n        width: 40px;\n    }\n\n    .info-layout {\n        position: relative;\n        right: 20px;\n        display: inline-block;\n        width: 40px;\n    }\n\n    .sidenav {\n        padding: 0px 0px 0px 0px;\n        background-color: rgba(44, 44, 44, 1) !important;\n        color: rgba(255, 255, 255, 1) !important;\n        /* max-width: 100px; */\n        display: inline-block !important;\n        top:0px;\n        box-shadow: 0 2px 2px 0 rgba(0,0,0,0.14), 0 3px 1px -2px rgba(0,0,0,0.12), 0 1px 5px 0 rgba(0,0,0,0.2) !important;\n    }\n\n    .sidenav-container {\n        width: 100%;\n        height: 100% !important;\n        background-color:#FFFFFF;\n    }\n\n    ::ng-deep .mat-drawer-backdrop.mat-drawer-shown {\n        background-color: transparent;\n    }\n\n    ::ng-deep #myuserinfo {\n        padding: unset !important;\n        box-shadow: 0 2px 6px 0 rgba(0,0,0,0.2),0 2px 6px 0 rgba(0,0,0,0.18);\n    }\n\n    #alarms-panel {\n        background: white;\n        height: 300px;\n        transition: bottom 300ms;\n        width: 100%;\n        position: fixed;\n        bottom: -300px;\n    }\n\n    #alarms-panel.is-active {\n        bottom: 0px;\n        transition: bottom 300ms;\n        z-index: 999;\n    }\n\n    #alarms-panel.is-full-active {\n        top: 46px;\n        height: 100%;\n        transition:  top 300ms;\n        z-index: 999;\n    }\n}",":host .home-body {\n  display: table;\n  margin: 0 auto;\n}\n:host .banner {\n  display: flex;\n  position: absolute;\n  left: 0px;\n  top: 0px;\n  right: 0px;\n  z-index: 999999;\n  font-size: 16px;\n  padding-left: 25px;\n  height: 48px;\n  background-color: #B71C1C;\n  color: #FFFFFF;\n}\n:host .banner div {\n  display: flex;\n  align-items: center;\n  margin: auto;\n}\n:host .banner mat-icon {\n  margin-left: 10px;\n}\n:host .home-container {\n  position: absolute;\n  left: 0px;\n  top: 0px;\n  bottom: 0px;\n  right: 0px;\n  overflow: auto;\n}\n:host .home-container-nav {\n  position: absolute;\n  left: 0px;\n  top: 48px;\n  bottom: 0px;\n  right: 0px;\n  overflow: auto;\n}\n:host .home-info {\n  text-align: center;\n}\n:host .header {\n  display: flex;\n  z-index: 9999 !important;\n  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12), 0 1px 5px 0 rgba(0, 0, 0, 0.2) !important;\n  /* min-height: 46px !important; */\n  /* max-height: 46px !important; */\n  height: 46px !important;\n  padding-left: 4px;\n  padding-right: 10px;\n  background-color: rgb(255, 255, 255);\n  line-height: 46px;\n}\n:host .header .items {\n  flex: 1;\n  align-items: center;\n  margin-left: 30px;\n}\n:host .header-login {\n  float: right;\n  line-height: 46px;\n  border-left-width: 1px;\n  border-left-style: solid;\n  padding-left: 10px;\n}\n:host .header-login .info {\n  display: inline-block;\n  line-height: 46px;\n  vertical-align: middle;\n  max-width: 140px;\n}\n:host .header-login .primary {\n  display: block;\n  font-size: 14px;\n  font-weight: 600;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  max-width: fit-content;\n  line-height: 16px;\n}\n:host .header-login .secondary {\n  display: block;\n  font-size: 14px;\n  font-weight: 100;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  max-width: fit-content;\n  color: gray;\n  line-height: 16px;\n}\n:host .header-date-time {\n  border-left-width: 1px;\n  border-left-style: solid;\n  padding-left: 10px;\n  padding-right: 10px;\n  display: inline-block;\n}\n:host .header-language {\n  padding-left: 10px;\n  padding-right: 10px;\n  display: inline-block;\n}\n:host .header-button {\n  float: right;\n  line-height: 46px;\n  text-align: right;\n  margin-right: 10px;\n}\n:host .header-button mat-icon {\n  font-size: 28px;\n  width: 28px;\n  height: 28px;\n}\n:host .button-counter {\n  display: inline-block;\n  position: absolute;\n  bottom: 7px;\n  right: 1px;\n  width: 16px;\n  height: 16px;\n  border-radius: 50%;\n  text-align: center;\n  line-height: 16px;\n  font-size: 12px;\n  font-weight: bold;\n}\n:host .alarm-layout {\n  position: relative;\n  right: 45px;\n  display: inline-block;\n  width: 40px;\n}\n:host .info-layout {\n  position: relative;\n  right: 20px;\n  display: inline-block;\n  width: 40px;\n}\n:host .sidenav {\n  padding: 0px 0px 0px 0px;\n  background-color: rgb(44, 44, 44) !important;\n  color: rgb(255, 255, 255) !important;\n  /* max-width: 100px; */\n  display: inline-block !important;\n  top: 0px;\n  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12), 0 1px 5px 0 rgba(0, 0, 0, 0.2) !important;\n}\n:host .sidenav-container {\n  width: 100%;\n  height: 100% !important;\n  background-color: #FFFFFF;\n}\n:host ::ng-deep .mat-drawer-backdrop.mat-drawer-shown {\n  background-color: transparent;\n}\n:host ::ng-deep #myuserinfo {\n  padding: unset !important;\n  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.2), 0 2px 6px 0 rgba(0, 0, 0, 0.18);\n}\n:host #alarms-panel {\n  background: white;\n  height: 300px;\n  transition: bottom 300ms;\n  width: 100%;\n  position: fixed;\n  bottom: -300px;\n}\n:host #alarms-panel.is-active {\n  bottom: 0px;\n  transition: bottom 300ms;\n  z-index: 999;\n}\n:host #alarms-panel.is-full-active {\n  top: 46px;\n  height: 100%;\n  transition: top 300ms;\n  z-index: 999;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
